import pMemoize from "@-/com.npmjs.p-memoize";
import { yn } from "@-/com.npmjs.yn";
import type { ComponentType } from "react";
import type { OnboardingGlobeCanvasProps } from "#onboarding-globe-canvas";

/**
 * The globe's Skia canvas is code-split, like the welcome galaxy's, and yields `null` in a build
 * that opted out of Skia (`EXPO_PUBLIC_DISABLE_SKIA_CHARTS`, the Maestro APK): the onboarding's
 * pages then show over the plain sky.
 */
export const loadOnboardingGlobeCanvas = pMemoize(
  async (): Promise<ComponentType<OnboardingGlobeCanvasProps> | null> => {
    if (yn(process.env.EXPO_PUBLIC_DISABLE_SKIA_CHARTS, { default: false })) {
      return null;
    }
    const { OnboardingGlobeCanvas } = await import("#onboarding-globe-canvas");
    return OnboardingGlobeCanvas;
  },
);

/**
 * Starts loading the globe's canvas ahead of its overlay, as soon as a new learner's onboarding
 * starts, so the Earth can draw the moment the overlay mounts beneath the welcome galaxy's dive
 * (which only dissolves into it once it is on screen). A failure is left to the overlay's own load
 * to report.
 */
export function preloadOnboardingGlobeCanvas(): void {
  loadOnboardingGlobeCanvas().catch(() => undefined);
}
